import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
  viewAction,
} from "components/Table/RowActions";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";

class VehicleModelList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      makes: [],
      selectedMake: "",
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      canWrite: false,
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const { selectedMake } = this.props.match.params;
    const canWrite = this.hasPermission([Scopes.VEHICLES_MAKES_WRITE]);
    this.setState({ canWrite });

    if (selectedMake) {
      this.setState({ selectedMake }, () => {
        this.callPage();
      });
      this.fetchMakes();
    } else {
      this.fetchMakes();
      this.callPage();
    }
  }

  async fetchMakes() {
    const response = await this.engine.getItem("vehicles");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        makes: response.data.items.map((make) => ({
          value: make.id,
          label: make.name,
        })),
      });
    }
  }

  async callPage() {
    const { selectedMake } = this.state;
    if (!selectedMake || selectedMake === ":selectedMake") return;

    const pathname = `vehicles/${selectedMake}/models`;
    const response = await this.engine.getItem(pathname);
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          name: item.name,
          minYear: item.minYear,
          maxYear: item.maxYear ?? strings.open,
          make: item.make.name,
          created: new Date(item.createdAt),
          actions: this.handleActions(key, item),
        })),
      });
    }
    this.props.loadingAction(false);
  }

  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  async handleDelete(valueId) {
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const { selectedMake } = this.state;
      const result = await this.engine.deleteItem(
        `vehicles/${selectedMake}/models`,
        valueId
      );
      if (result) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  handleEdit(index, dataId) {
    const data = this.state.dataSource[index].data;
    const { selectedMake } = this.state;

    this.props.history.push({
      pathname: `/admin/vehicles_models/${selectedMake}/edit/${dataId}`,
      data,
    });
  }

  handleActions(index, item) {
    return (
      <RowActions
        actions={[
          viewAction(() => this.handleViewTrims(item.id)),
          editAction(() => this.handleEdit(index, item.id), this.state.canWrite),
          deleteAction(() => this.handleDelete(item.id), this.state.canWrite),
        ]}
      />
    );
  }

  handleViewTrims(modelId) {
    const { selectedMake } = this.state;
    this.props.history.push({
      pathname: `/admin/vehicles_models/${modelId}/trims`,
      state: { selectedMake, selectedModel: modelId },
    });
  }

  getTrProps = (state, rowInfo) => {
    if (!rowInfo || !rowInfo.original) return {};
    return {
      onClick: () => this.handleViewTrims(rowInfo.original.data.id),
      style: { cursor: "pointer" },
    };
  };

  handleAdd() {
    const { selectedMake } = this.state;
    if (selectedMake === ":selectedMake") {
      alert(`${strings.select} ${strings.make}`);
      return;
    }
    this.props.history.push(`/admin/vehicles_models/${selectedMake}/add`);
  }

  render() {
    const { dataSource, isLoading, makes, selectedMake, canWrite } = this.state;

    let columns = [
      { Header: strings.name, accessor: "name" },
      { Header: strings.make, accessor: "make" },
      { Header: strings.minimumyear, accessor: "minYear" },
      { Header: strings.maxyear, accessor: "maxYear" },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4" className="pull-left"></CardTitle>
                  {canWrite && (
                    <Button
                      color="primary"
                      className="pull-right"
                      onClick={() => this.handleAdd()}
                    >
                      {strings.add}
                    </Button>
                  )}
                  <SelectRow
                    label={strings.make}
                    name="selectedMake"
                    defaultValue={selectedMake}
                    data={makes}
                    changeInput={(e) => {
                      const selectedMake = e.value;
                      this.setState({ selectedMake: selectedMake }, () => {
                        this.callPage();
                      });
                    }}
                    placeholder={strings.select}
                  />
                </CardHeader>
                <CardBody>
                  <ReactTable
                    previousText={strings.previous}
                    nextText={strings.next}
                    loadingText={strings.loading}
                    noDataText={strings.nodata}
                    pageText={strings.page}
                    data={dataSource}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    filterable
                    loading={isLoading}
                    columns={columns}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom
                    PaginationComponent={TablePagination}
                    getTrProps={this.getTrProps}
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});
export default connect(null, mapDispatchToProps)(VehicleModelList);
